module.exports = __webpack_public_path__ + "static/media/05.8aa3c712.mp3";